export default __webpack_public_path__ + "static/pride-0669c9fbf173582673dd17914727f6e6.png";